import { clsx } from 'clsx';
import cronstrue from 'cronstrue';
import { Integration } from '../../shared/interfaces/integration';
import { NO_SCHEDULE_TEXT } from './strings';
import { getDurationString } from '../../shared/utils/date';
import { EligibleFrequencyUnitsInCron } from '../interfaces/pipeline-settings-config';
import { Tooltip } from '../../tooltip/Tooltip';

export interface PipelineSyncFrequencyDisplayProps {
  pipeline: Integration;
  withLabel?: boolean;
  withEvery?: boolean;
  className?: string;
  valueClassName?: string;
}

export function PipelineSyncFrequencyDisplay({
  pipeline,
  withLabel,
  withEvery = true,
  className,
  valueClassName
}: PipelineSyncFrequencyDisplayProps) {
  const frequency = pipeline.config.sync_frequency_in_ms
    ? getDurationString(pipeline.config.sync_frequency_in_ms, false, true)
    : undefined;

  const syncFrequencyType = pipeline.config.sync_frequency_type ?? undefined;

  const frequencyInCron = pipeline.config.sync_frequency_in_cron
    ? cronstrue.toString(pipeline.config.sync_frequency_in_cron)
    : null;

  return (
    <div className={clsx('center-flex-row text-ellipsis', className)} data-id='sync-frequency'>
      {!frequency && !frequencyInCron ? (
        <span className='text-secondary text-normal'>{NO_SCHEDULE_TEXT}</span>
      ) : (
        <div className='center-flex-row text-ellipsis'>
          {withLabel ? <span className='text-secondary mr-1'>Syncs</span> : null}

          {frequencyInCron && syncFrequencyType === EligibleFrequencyUnitsInCron.CRON ? (
            <Tooltip dataId='sync-frequency' title={frequencyInCron} enableOnTextOverflow>
              <span className={clsx(withLabel && 'text-medium ', 'text-ellipsis', valueClassName)}>
                {frequencyInCron}
              </span>
            </Tooltip>
          ) : (
            <span className={clsx(withLabel && 'text-medium', valueClassName)}>
              {withEvery ? 'Every ' : ''}
              {frequency}
            </span>
          )}
        </div>
      )}
    </div>
  );
}
